import {
  combineReducers,
  createAction,
  createSelector,
} from '@reduxjs/toolkit';
import { dataSlice as createDataSLice } from '../../../core/data';
import { sliceList as createListSlice } from '../../../core/list';
import { sliceFilter as createFilterSlice } from '../../../core/filter';
import { sliceSearch as createSearchSlice } from '../../../core/search';
import { detailSlice as createDetailSlice } from '../../../core/detail';
import { DataConf, UsersType } from '../conf/Data.conf';
import { ListConf } from '../conf/List.conf';
import { FilterConf } from '../conf/Filter.conf';
import { SearchConf } from '../conf/Search.conf';
import { DetailConf } from '../conf/Detail.conf';
import _ from 'lodash';
import { QueryConf } from '../../conf/Query.conf';

export const tag = 'contacts_customers';
const crewUserType = _.find(UsersType, (i) => i.id === 'Crew');

// REDUCERS
const dataSlice = createDataSLice(`${tag}/data`, DataConf.initialState);
const listSlice = createListSlice(`${tag}/list`, ListConf.initialState);
const filterSlice = createFilterSlice(`${tag}/filter`, FilterConf.initialState);
const searchSlice = createSearchSlice(`${tag}/search`, SearchConf.initialState);
const detailSlice = createDetailSlice(`${tag}/detail`, DetailConf.initialState);

export const reducer = combineReducers({
  search: searchSlice.reducer,
  data: dataSlice.reducer,
  list: listSlice.reducer,
  filter: filterSlice.reducer,
  detail: detailSlice.reducer,
});

// ACTIONS
export const actions = {
  fetchAllAction: createAction(`${tag}/fetchAll`),
  fetchDetailAction: createAction(`${tag}/fetchOne`),
  ...searchSlice.actions,
  ...dataSlice.actions,
  ...listSlice.actions,
  ...filterSlice.actions,
  ...detailSlice.actions,
};

// QUERY
export const querySelector = createSelector(
  (state) => state[tag].list,
  (state) => state[tag].filter,
  (state) => state[tag].search,
  (list, filter, search) =>
    QueryConf.get(list, filter, search, FilterConf, SearchConf)
);

// LIST
export const listSelector = createSelector(
  (state) => state[tag].data,
  (state) => state[tag].list,
  ({ data, meta }, { pagination, sort }) => ({
    data,
    meta,
    pagination,
    sort,
  })
);

// DETAIL
export const detailSelector = createSelector(
  (state) => state[tag].detail,
  ({ data, loading, error }) => {
    return {
      loading,
      error,
      data: data
        ? {
          ...data,
          userType: crewUserType,
        }
        : null,
    };
  }
);

// EDIT
export const editSelector = createSelector(
  (state) => state[tag].detail,
  ({ data, loading, error }) => {
    const user = _.get(data, 'id_users_permissions_user');
    const yacht = _.get(data, 'id_yacht');
    const phone = _.get(user, 'phone_number');
    const lastDashIndex = _.lastIndexOf(phone, '-');

    let phone_number = phone || '';
    let country_code = null;

    if (lastDashIndex > 0) {
      country_code = phone.slice(0, lastDashIndex);
      phone_number = phone.slice(lastDashIndex + 1);
    }

    return {
      loading,
      error,
      data: data
        ? {
          id: data?.id,

          username: user?.username || '',
          email: user?.email || '',
          name: user?.name || '',
          surname: user?.surname || '',
          birthdate: user?.birthdate || null,

          phone_number: phone_number || '',
          country_code: country_code ? { phone: country_code } : null,
          userType: crewUserType,
          crew_responsability: data?.crew_responsability
            ? {
              id: data?.crew_responsability,
              label: data?.crew_responsability,
            }
            : null,

          status: data?.status
            ? {
              id: data?.status,
              label: data?.status,
            }
            : null,

          id_yacht: yacht
            ? {
              id: yacht?.id,
              name: `${yacht?.yacht_name} #${yacht?.id}`,
            }
            : null,
          yacht_name: yacht
            ? `${yacht?.yacht_name} #${yacht?.id}`
            : '',
          start_date: data?.start_date,
          end_date: data?.end_date,
          is_delivery_manager_on_board:
            data?.is_delivery_manager_on_board ?? false,
          is_main_contact: data?.is_main_contact ?? false,

          id_users_permissions_user: user
            ? {
              id: user?.id,
              username: user?.username,
              email: user?.email,
              name: user?.name,
              surname: user?.surname,
              birthdate: user?.birthdate,
              phone_number: user?.phone_number,
            }
            : null,
        }
        : null,
    };
  }
);
